export default __webpack_public_path__ + "static/1-c5e3043a56653dac2fe8218cfba6e179.png";